import React from 'react'
import { Form, Input, Button, Card, Icon ,Row, Col, Tabs } from 'antd'
import auth from '../../services/auth'
import {getCaptcha, getLoginMethods} from '../../utils/request'
import { history } from '../../utils/config'
import Styles from './Index.less'

const FormItem = Form.Item;
const { TabPane } = Tabs;

class Login extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      msgText: '短信验证码',
      countFlag: true,
      count: 60,
      methods: []
    }
  }

  componentWillUnmount() {
    this.timer && clearTimeout(this.timer);
  }

  componentWillMount() {
    this.fetchLoginMethods();
  }

  handleSubmit (e) {
    e.preventDefault()
    const {account, verifyCode} = this.props.form.getFieldsValue()

    auth.login(account,verifyCode, (loggedIn) => {
      if (loggedIn) {
        history.push('/homePage')
      }
    })
  }

  handleSubmitByPwd (e) {
    e.preventDefault();
    const {account, password} = this.props.form.getFieldsValue()

    auth.loginByPwd(account, password, (loggedIn) => {
      if (loggedIn) {
        history.push('/homePage')
      }
    })
  }

  getCaptcha(e){
    e.preventDefault();
    const {account,} = this.props.form.getFieldsValue();
    if(!this.state.countFlag){
      return false;
    }
    getCaptcha(`/staff/${account}/sendVerifyCode`).then(res => {
      //   debugger;
      if(res.code == 0){
        console.log(res, 'res')
        this.state.countFlag = false;
        this.timer = setInterval(() => {
          if (this.state.count <= 0) {
            clearInterval(this.timer);
            this.state.countFlag = true;
            this.state.count = 60;
            this.setState({
              // time: 60,
              msgText: '获取验证码',
              countFlag: true
              // countFlag: true
            })
          } else {
            this.state.count--;
            this.setState({
              msgText: `${this.state.count} s`
            })
          }
        }, 1000)
      }

    })
  }

  fetchLoginMethods() {
    getLoginMethods('/public/login/methods').then(res => {
      if (res.code == 0) {
        let methods = res.data.loginMethods;
        if (methods) {
          let arr = methods.split(',');
          this.setState({
            methods: arr
          });
        }
      }
    });
  }

  render () {
    const {getFieldDecorator} = this.props.form;
    const {methods} = this.state;

    return (
      <div className={Styles.baseColor}>
        <div className={Styles.backgroundWrapper}>
          <div className={Styles.headerWrapper}>
            <div className={Styles.logoPanel}>
                <img src={require('../../assets/geshui_logo.png')} />
            </div>
          </div>
          <div className={Styles.titleWrapper}>
            <div className={Styles.loginWrapper}>
              <div className={Styles.loginBox}>
                {
                  methods.length > 0 ? (
                  <Tabs defaultActiveKey={methods[0]}>
                    {
                      methods.map(item => {
                        if (item == '1') {
                          return (
                            <TabPane tab="验证码登录" key={item}>
                            <Form
                              style={{width: 300, margin: 'auto'}}
                              onSubmit={e => this.handleSubmit(e)}
                              className='login-form'
                            >
                              <FormItem >
                                {getFieldDecorator('account', {
                                  rules: [
                                    {required: true, message: '请输入账号'}
                                  ]
                                })(
                                  <Input prefix={<Icon type='user' style={{ fontSize: 13 }} />} placeholder='请输入账户名' />
                                )}
                              </FormItem>
                              <FormItem
                              >
                                <Row gutter={8}>
                                  <Col span={14}>
                                    {getFieldDecorator('verifyCode', {
                                      rules: [{required: true, message: '请输入短信验证码'}],
                                    })(
                                      <Input size="large" prefix={<Icon type='mail' style={{ fontSize: 13}} />} placeholder="请输入短信验证码"/>
                                    )}
                                  </Col>
                                  <Col span={10}>
                                    <Button size="large" onClick={(e) => this.getCaptcha(e)}>{this.state.msgText}</Button>
                                  </Col>
                                </Row>
                              </FormItem>
                              <Button style={{width:'100%', height:46, marginBottom: 60, fontSize: 16}} type='primary' htmlType='submit'>登录</Button>
                            </Form>
                          </TabPane>
                      )}
                      else if (item == '2') {
                        return (
                          <TabPane tab="账号密码登录" key="2">
                            <Form
                                style={{width: 300, margin: 'auto'}}
                                onSubmit={e => this.handleSubmitByPwd(e)}
                                className='login-form'
                              >
                                <FormItem>
                                {getFieldDecorator('account', {
                                  rules: [
                                    {required: true, message: '请输入账号'}
                                  ]
                                })(
                                  <Input prefix={<Icon type='user' style={{ fontSize: 13 }} />} placeholder='请输入账户名' />
                                )}
                              </FormItem>
                              <FormItem>
                                {getFieldDecorator('password', {
                                  rules: [
                                    {required: true, message: '请输入密码'}
                                  ]
                                })(
                                  <Input type="password" prefix={<Icon type='lock' style={{ fontSize: 13 }} />} placeholder='请输入密码' />
                                )}
                              </FormItem>
                              <Button style={{width:'100%', height:46, marginBottom: 60, fontSize: 16}} type='primary' htmlType='submit'>登录</Button>
                            </Form>
                          </TabPane>
                        )}
                    })
                  }
                  </Tabs>
                ):(
                  <div></div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

Login = Form.create()(Login)

export default Login



/** WEBPACK FOOTER **
 ** ./src/components/login/Login.js
 **/